// extracted by mini-css-extract-plugin
export default {"report":"report_report__OLfwJ","footer":"report_footer__iN-Yc","option":"report_option__HyIhS","message":"report_message__Qqb7z","label":"report_label__c75Y6"};